/* src/app/warehousing/pages/warehouses-new/warehouses-new.component.scss */
/*# sourceMappingURL=warehouses-new.component.css.map */
